<div class="bio-container">
  <div class="row section">
    <div class="col s12 m6 left-container">
      <img class="caro-pic"
        src="https://firebasestorage.googleapis.com/v0/b/portafoliocaritodasilva.appspot.com/o/fotoBio.jpg?alt=media&token=03e7d72c-011c-483c-ad4d-d9fb30bf1ed8"
        alt="" class="responsive-img">
    </div>
    <div class="col s12 m6 right-container">
      <div class="row valign-wrapper center-align">
        <h1 class="card-title">¿Quien Soy?</h1>

      </div>
      <div class="row info-description">
        <p>Venezolana, viviendo hace 11 años en Chile. Perseverante y trabajadora. Me apasiona lo que hago y
          me
          esfuerzo en hacerlo lo mejor posible. Soy creativa y buscar soluciones innovadoras. También me
          encanta el café, amo a mis cachorros y a las papitas fritas, porque obvio, son papitas fritas. Tengo mente
          inquieta por
          eso siempre estoy aprendiendo algo nuevo. ¡Trabajemos juntos!</p>

      </div>
    </div>
  </div>
</div>